import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Headphones } from 'lucide-react';
import { AppButton, cn } from '../../../ui';

const HelpCard = ({ className }) => (
  <section
    aria-label="Help"
    className={cn('tw-flex tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-border-primary/10 tw-bg-gradient-to-br tw-from-primary-soft tw-to-primary/10 tw-p-4 tw-shadow-card page-sm:tw-px-5', className)}
  >
    <div className="tw-min-w-0">
      <div className="tw-text-sm tw-font-medium tw-text-content">Need Help?</div>
      <div className="tw-mt-0.5 tw-text-xs tw-text-content-muted">Browse articles or contact support</div>
      <AppButton as={Link} to="/s/support" variant="outline" size="sm" className="tw-mt-2.5 tw-bg-surface-raised tw-text-primary tw-no-underline hover:tw-text-primary">
        Go to Help Center
        <ArrowRight size={16} />
      </AppButton>
    </div>
    <span className="tw-flex tw-h-14 tw-w-14 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-surface-raised tw-text-primary tw-shadow-card" aria-hidden="true">
      <Headphones size={26} />
    </span>
  </section>
);

export default HelpCard;
